import {LayoutComponent} from "../layout/layout.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {PengisianDataPribadiComponent} from "./pengisian-data-pribadi.component";

const routes: Routes = [
  {
    path: 'pengisian-data-pribadi',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: PengisianDataPribadiComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PengisianDataPribadiRoutingModule { }
